module.exports = __webpack_public_path__ + "static/BeVietnam-Bold-911cbece6642d4b06399f9ac59be6674.woff";